import { IMemberProfile, ISummerUser } from 'redhotpie-shared-lib/interfaces/IUser';
import * as utils from '../functions/utils';
// const upcaseFirstCharacter = tmp => tmp.charAt(0).toUpperCase() + tmp.substr(1);
import memberProfile from './memberProfile';

export default class SumaryUser {
  newUsers: IMemberProfile[];
  activeUsers: IMemberProfile[];

  constructor() {
    this.newUsers = [];
    this.activeUsers = [];
  }
  static mappingObject(_obj: any): ISummerUser {
    let obj = Object.assign(new SumaryUser(), _obj);
    obj.newUsers = _obj.NewUsers ? memberProfile.mappingObjectsCustomMemberSearch(_obj.NewUsers) : [];
    obj.activeUsers = _obj.ActiveUsers ? memberProfile.mappingObjectsCustomMemberSearch(_obj.ActiveUsers) : [];

    obj = utils.cleanObjectKeys(Object.keys(new SumaryUser()), obj);
    return obj;
  }
}
